export interface ShippingAddresses {
  shipping_addresses: {
    customer_address_id: boolean
    firstname: boolean
    lastname: boolean
    street: boolean
    city: boolean
    postcode: boolean
    telephone: boolean
    company: boolean
    region: {
      code: boolean
      label: boolean
    }
    country: {
      code: boolean
      label: boolean
    }
    available_shipping_methods: {
      available: boolean
      carrier_code: boolean
      carrier_title: boolean
      error_message: boolean
      method_code: boolean
      method_title: boolean
      amount: {
        currency: boolean
        value: boolean
      }
      base_amount: {
        value: boolean
        currency: boolean
      }
      price_excl_tax: {
        value: boolean
        currency: boolean
      }
      price_incl_tax: {
        value: boolean
        currency: boolean
      }
      [key: string]: any
    }
    selected_shipping_method: {
      carrier_code: boolean
      carrier_title: boolean
      method_code: boolean
      method_title: boolean
      amount: {
        value: boolean
        currency: boolean
      }
      base_amount: {
        value: boolean
        currency: boolean
      }
      [key: string]: any
    }
    [key: string]: any
  }
}

export const shippingAddresses: ShippingAddresses = {
  shipping_addresses: {
    customer_address_id: true,
    firstname: true,
    lastname: true,
    street: true,
    city: true,
    postcode: true,
    telephone: true,
    company: true,
    region: {
      code: true,
      label: true
    },
    country: {
      code: true,
      label: true
    },
    available_shipping_methods: {
      amount: {
        currency: true,
        value: true
      },
      available: true,
      base_amount: {
        value: true,
        currency: true
      },
      carrier_code: true,
      carrier_title: true,
      error_message: true,
      method_code: true,
      method_title: true,
      price_excl_tax: {
        value: true,
        currency: true
      },
      price_incl_tax: {
        value: true,
        currency: true
      }
    },
    selected_shipping_method: {
      amount: {
        value: true,
        currency: true
      },
      base_amount: {
        value: true,
        currency: true
      },
      carrier_code: true,
      carrier_title: true,
      method_code: true,
      method_title: true
    }
  }
}
